import { defineComponent as _defineComponent } from 'vue'
import UiCalendar from '../../components/calendar.vue';
import { type DayCell, type RangeDirection } from '../../datepicker';


const __default__ = {
    name: 'UiDatepickerDate',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    cells: null,
    title: null,
    rangeDirection: { default: null },
    showMonthPicker: { type: Boolean, default: false },
    viewYear: { default: 0 },
    viewMonth: { default: 0 },
    isRange: { type: Boolean, default: false },
    footerInputStr: { default: '' },
    footerRangeStartStr: { default: '' },
    footerRangeEndStr: { default: '' }
  },
  emits: ["prev", "next", "toggle-month-picker", "day-click", "day-hover", "day-leave", "prev-year", "next-year", "select-view-month", "footer-input", "footer-change", "footer-range-start-input", "footer-range-start-change", "footer-range-end-input", "footer-range-end-change", "reset", "apply"],
  setup(__props: any) {





return { __sfc: true,UiCalendar }
}

})